'use client'

import { motion } from 'framer-motion'
import { useTranslations } from 'next-intl'

const highlightKeys = ['library', 'instant-play', 'multiplayer'] as const

export default function LibraryHighlightsSection() {
  const t = useTranslations()

  return (
    <div className="relative -top-10 overflow-hidden bg-linear-to-r from-[rgba(0,200,170,0.15)] via-[rgba(199,97,214,0.15)] via-49% to-[rgba(232,200,74,0)] px-6 py-16 sm:px-12 lg:px-[max(72px,calc((100vw-1296px)/2))]">
      <div className="mx-auto grid max-w-[1128px] gap-8 sm:grid-cols-3 sm:gap-9">
        {highlightKeys.map((key, index) => (
          <motion.div
            key={key}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, ease: 'easeOut', delay: (index + 1) * 0.12 }}
          >
            <h2 className="text-base leading-6 font-semibold tracking-[0.2px] text-white">
              {t(`plus.library-highlights.${key}.title`)}
            </h2>
            <p className="text-vive-primary-30 mt-1 text-sm leading-[22px] tracking-[0.2px]">
              {t(`plus.library-highlights.${key}.description`)}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  )
}
